import * as React from 'react';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import CIcon from '@coreui/icons-react';
import { renderTimeViewClock } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { cilLockLocked } from '@coreui/icons';

export default function CustomDatePicker(prop) {
  const {
    icon,
    label,
    title,
    id,
    name,
    value,
    onChange,
    isRequired,
    message,
    max,
    min,
    disabled,
    noDefault,
    className,
    isDateTime = false,
    onAccept,
    onlyHours,
    labelNote,
    isSecret = false,
    mfa,
    onMfaClick,
  } = prop;

  const [error, setError] = React.useState(null);
  const [tempValue, setTempValue] = React.useState(null);
  const errorMessage = React.useMemo(() => {
    switch (error) {
      case 'maxDate':
      case 'minDate': {
        return message;
      }
      default: {
        return '';
      }
    }
  }, [error]);

  const datePickerSx = {
    '& .MuiInputBase-input': {
      color: 'white',
      padding: '9.5px 14px',
    },
    '& .MuiInputLabel-root': {
      color: 'white',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255,255,255,0.5)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'white',
    },
    '& .MuiSvgIcon-root': {
      color: 'white',
    },
  };

  return (
    <div className={`text-start  ${label && 'mt-2'}`}>
      {label && (
        <label htmlFor={id} className="login_label labelName mb-2">
          {label} {labelNote && <span className="label-note-warning">{labelNote}</span>}
        </label>
      )}
      <div className={`form-outline text-start`}>
        <div className="input-group position-relative pt-0 pb-0">
          <span className="input-group-addon" title={title || label || ''}>
            <CIcon
              className={isRequired ? 'mandatory-control' : 'stock-toggle-icon '}
              icon={icon}
            ></CIcon>
          </span>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {isDateTime ? (
              <DateTimePicker
                value={value ? dayjs(value) : noDefault ? null : dayjs()}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  // seconds: renderTimeViewClock,
                }}
                views={
                  onlyHours
                    ? ['year', 'month', 'day', 'hours']
                    : ['year', 'month', 'day', 'hours', 'minutes']
                }
                //value={value? dayjs(value).utc().local(): noDefault? null: dayjs().local()}
                onChange={(e) => {
                  const newValue = e ? e.$d : null;
                  setTempValue(newValue); // Store the latest value
                  onChange ? onChange(newValue, label) : undefined;
                }}
                onClose={() => {
                  // Use the temp value stored from onChange
                  if (onAccept && tempValue !== null) {
                    onAccept(tempValue, label);
                  }
                  setTempValue(null); // Reset
                }}
                disabled={disabled}
                name={name}
                className={`form-control item  ${className}`}
                onError={isRequired ? (newError) => setError(newError) : () => ''}
                slotProps={{
                  textField: {
                    sx: datePickerSx,
                    helperText: errorMessage,
                  },
                  actionBar: {
                    actions: ['accept'],
                  },
                }}
                disableOpenPicker={false} // allow popup
                maxDateTime={max || null}
                minDateTime={min || null}
              />
            ) : (
              <DatePicker
                value={value ? dayjs(value) : noDefault ? null : dayjs()}
                //value={value? dayjs(value).utc().local(): noDefault? null: dayjs().local()}
                onChange={(e) => {
                  onChange(e ? e.$d : null, label); // return JS Date to parent
                }}
                disabled={disabled}
                format="MM/DD/YYYY"
                name={name}
                className={`form-control item  ${className}`}
                onError={isRequired ? (newError) => setError(newError) : () => ''}
                slotProps={{
                  textField: {
                    sx: datePickerSx,
                    inputProps: {
                      type: isSecret ? 'password' : 'text',
                    },
                    helperText: errorMessage,
                  },
                }}
                maxDate={max || null}
                minDate={min || null}
              />
            )}
          </LocalizationProvider>
          {mfa && (
            <span
              className="input-group-addon-mfa pointer"
              onClick={() => onMfaClick && onMfaClick()}
              title="Two Factor Authentication"
            >
              <CIcon className={'stock-toggle-icon'} icon={cilLockLocked} />
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
